import React, { useEffect } from "react"
import { AppAntSwitch } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportManualExecutionSwitch() {

	const {
		manuallyExecution,
		setManuallyExecutionInfo
	} = useReportFormInfo(reportFormData.peek()?.manuallyExecution, "manuallyExecution", object({ manuallyExecution: boolean() }))

	useEffect(() => {
		useManualExecution.value = manuallyExecution
	}, [manuallyExecution])

	return <AppAntSwitch
		checked={!!manuallyExecution}
		onChange={e => setManuallyExecutionInfo(e.target.checked)}
		trueText="Manual Execution"
	/>
}